import { Component, inject, OnInit, signal } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";

import { ExternalpageSingle } from "../../../class/externalpage-single";
import { ImageService } from "../../../shared/services/image.service";
import { PostService } from "../../../shared/services/post.service";

@Component({
  selector: "app-page-post",
  templateUrl: "./page-post.component.html",
  styleUrls: ["./page-post.component.scss"],
  standalone: false,
})
export class PagePostComponent extends ExternalpageSingle implements OnInit {
  override readonly maxRelatedDataItems = 6;

  private readonly postService = inject(PostService);
  private readonly route = inject(ActivatedRoute);
  readonly imageService = inject(ImageService);

  public relatedData = signal<any[]>([]);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((routeParams) => {
        this.onIdChange();
        this.loadSingle(routeParams["id"]);
      });
  }

  override loadCallback(): void {
    this.setRelatedData(this.entity.id);
  }

  setRelatedData(id: string | null): void {
    this.postService.setRelatedData();

    this.relatedData.set([]);
    const tmp = this.postService.relatedData;
    if (tmp.length === 0) {
      this.postService.$relatedDataSubject
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          const items: any[] = [];
          for (const item of this.postService.relatedData) {
            if (item["id"] !== id && items.length < this.maxRelatedDataItems) {
              items.push(item);
            }
          }
          this.relatedData.set(items);
        });
    } else {
      const items: any[] = [];
      for (const item of tmp) {
        if (item["id"] !== id && items.length < this.maxRelatedDataItems) {
          items.push(item);
        }
      }
      this.relatedData.set(items);
    }
  }
}
